const Touch = {
  get supported() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  },
  isDragging: false,
};

document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('touchmove', function() {
    Touch.isDragging = true;
  });
  document.body.addEventListener('touchstart', function() {
    Touch.isDragging = false;
  });
});

export default Touch;



// WEBPACK FOOTER //
// ./src/utilities/Touch.js